module.exports = __webpack_public_path__ + "img/dashboard-1.bb6619b4.png";